import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import DoneIcon from '@material-ui/icons/Done';
import classNames from 'classnames';
import { efesBorder } from '../../../theme';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '1.5rem',
    height: '1.5rem',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '4px',
    width: '1.5rem',
    height: '1.5rem',
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${efesBorder}`,
    '&:before': {
      display: 'block',
      width: '1.5rem',
      height: '1.5rem',
      content: '""',
    },
  },
  checkedIcon: {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    '&:before': {
      display: 'block',
      width: '1.5rem',
      height: '1.5rem',
      content: '""',
    },
  },
}));

function MainCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      color="default"
      checkedIcon={<DoneIcon className={classNames(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
}

export default MainCheckbox;
